import { render } from "./AdminOrderList.vue?vue&type=template&id=e38e00fa&scoped=true&ts=true&lang=true"
import script from "./AdminOrderList.vue?vue&type=script&lang=ts"
export * from "./AdminOrderList.vue?vue&type=script&lang=ts"

import "./AdminOrderList.vue?vue&type=style&index=0&id=e38e00fa&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38e00fa"]])

export default __exports__